const BRIGHT = '#ffffff'
const DARK = '#333333'

export const contrastColor = (backgroundColor: string): string => {
    const hexcolor = backgroundColor.replace('#', '')
    const red = parseInt(hexcolor.substr(0, 2), 16)
    const green = parseInt(hexcolor.substr(2, 2), 16)
    const blue = parseInt(hexcolor.substr(4, 2), 16)
    const yiq = (red * 299 + green * 587 + blue * 114) / 1000
    return yiq >= 128 ? DARK : BRIGHT
}
